import React from 'react';

/**
 * 入力フォーム用の共通コンポーネント
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.id - inputとlabelを関連付けるためのID
 * @param {string} props.labelTitle - ラベル
 * @param {string} props.type - 入力タイプ
 * @param {string|number} props.value - 入力値
 * @param {string} props.placeholder - プレースホルダーとして表示する文字列
 * @param {function} props.onChange - 入力値が変化したときに呼ばれる関数
 * @param {boolean} [props.required=true] - 必須入力かどうか
 */

const InputFormLayout = ({
  id,
  labelTitle,
  type,
  value,
  placeholder,
  onChange,
  min="",
  required = true,
  multiline = false
}) => {
  const borderColor = type === "text" ? "#007bff" : "#ccc";

  const style={
    width: "100%",
    padding: "0.7rem 1rem",
    fontSize: "1rem",
    border: `1.5px solid ${borderColor}`,
    borderRadius: "6px",
    transition: "border-color 0.3s ease",
    outline: "none",
    ...(multiline && {
      height: "100px",
      resize: "vertical"
    })
  }

  return (
    <>
    <label htmlFor={id} style={{ color: "#333" }}>{labelTitle}</label>
    {multiline ? (
      <textarea
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        required={required}
        style={style}
      />
    ) : (
      <input
        id={id}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        required={required}
        style={style}
        min={min}
      />
    )}
    </>
  );
};

export default InputFormLayout;